<template>
  <div class="container create-event">
    <div class="row mb-45">
      <div class="col-8">
        <h1>Edit College</h1>
      </div>
    </div>

    <div v-if="initializing" class="row">
      <Loader style="width: 100%" />
    </div>

    <div v-else class="row">
      <div class="col-12 col-lg-8">
        <div class="dashboard-card">
          <tab-buttons v-model="selectedTab" />
        </div>
        <div>
          <general v-if="selectedTab === 'general'" class="dashboard-card event-card" />
          <primary-contact v-if="selectedTab === 'primaryContact'" class="dashboard-card event-card" />
          <crisis-contact v-if="selectedTab === 'crisisContact'" class="dashboard-card event-card" />
          <resources v-if="selectedTab === 'resources'" class="dashboard-card event-card" />
          <counseling-center v-if="selectedTab === 'counselingCenter'" class="dashboard-card event-card" />
          <triage v-if="selectedTab === 'triage'" class="dashboard-card event-card" />
          <integrations v-if="selectedTab === 'integrations'" class="dashboard-card event-card" />
          <credit-management v-if="selectedTab === 'creditManagement'" class="dashboard-card event-card" />
          <credit-policy v-if="selectedTab === 'creditPolicy'" class="dashboard-card event-card" />
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="dashboard-card">
          <logo-uploader class="row" />
        </div>
        <div class="dashboard-card">
          <banner-uploader class="row" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import EditSchoolModel from './edit-school-model';
import LogoUploader from './components/logo-uploader.vue';
import BannerUploader from './components/banner-uploader.vue';
import General from './components/general.vue';
import PrimaryContact from './components/primary-contact.vue';
import CrisisContact from './components/crisis-contact.vue';
import Resources from './components/resources.vue';
import CounselingCenter from './components/counseling-center.vue';
import Triage from './components/triage.vue';
import TabButtons from './components/tab-buttons.vue';
import Integrations from './components/integrations.vue';
import CreditManagement from './components/credit-management.vue';
import CreditPolicy from './components/credit-policy.vue';

export default {
  name: 'EditCollege',
  components: {
    Loader,
    LogoUploader,
    BannerUploader,
    TabButtons,
    General,
    PrimaryContact,
    CrisisContact,
    Resources,
    CounselingCenter,
    Triage,
    Integrations,
    CreditManagement,
    CreditPolicy
  },
  data() {
    return {
      initializing: true,
      school: new EditSchoolModel(this.$http),
      selectedTab: 'general'
    };
  },

  provide() {
    return {
      school: this.school
    };
  },

  async mounted() {
    const { id } = this.$route.params;
    await this.school.initialize(id);
    this.initializing = false;
  }
};
</script>
